import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import Title from 'components/Title/Title';
import Layout from 'components/Layout/Layout';
import Keyboard from 'components/Keyboard/Keyboard';
import AuthStore from 'stores/Auth';
import styles from './Code.module.scss';

const Code = observer(() => {

  const [ code, setCode ] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (code?.length === 4) {
      submit();
    }
  }, [ code ]);

  useEffect(() => {
    if (!AuthStore.token) {
      navigate('/auth');
    }
  }, []);

  async function submit() {
    await AuthStore.submitCode(code);
    const redirect = sessionStorage.getItem('redirect') ?? '/';
    sessionStorage.removeItem('redirect');
    navigate(redirect);
  }

  function onChange(value) {
    if (code.length >= 4) {
      return;
    }
    setCode(code + value);
  }

  function onCorrect() {
    setCode(code?.slice(0, -1));
  }

  return (
    <div className={classNames(styles.container, {
      [styles.fetching]: AuthStore.fetching
    })}>
      <Layout>
        <Title>
          Enter the <strong>code</strong> you receive via SMS message
        </Title>

        <div className={styles.code}>
          <div className={styles.codeItem}>
            {code?.[0] ?? (<div className={styles.empty} />)}
          </div>
          <div className={styles.codeItem}>
            {code?.[1] ?? (<div className={styles.empty} />)}
          </div>
          <div className={styles.codeItem}>
            {code?.[2] ?? (<div className={styles.empty} />)}
          </div>
          <div className={styles.codeItem}>
            {code?.[3] ?? (<div className={styles.empty} />)}
          </div>
        </div>

        <Keyboard 
          onPress={onChange}
          onBack={onCorrect}
        />
      </Layout>
    </div>
  );
});

export default Code;
